import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { OpenAPIV3_1 as OpenAPI } from "openapi-types";
import _, { Dictionary } from 'lodash';
import SplitPane from '../SplitPane';
import ResponseBox from '../ResponseBox';
import Parameters from '../Parameters';
import { ResourceContext } from '../../Resources';

const DeleteRequestBox: React.FC<{
    operationObject: OpenAPI.OperationObject
}> = ({ operationObject }) => {
    const resorce = useContext(ResourceContext);
    const [params, setParams] = useState({});

    return <Box>
        <Parameters
            operationObject={operationObject}
            values={params}
            onChange={(key, value) => {
                setParams({ ...params, [key]: value })
            }}
        />
        <Button variant='contained'>{'Try'}</Button>
    </Box>;
}

export interface DeleteProps {
    operationObject: OpenAPI.OperationObject;
}

const Delete: React.FC<DeleteProps> = ({ operationObject }) => {
    const { responses } = operationObject;

    return (
        <Box>
            <SplitPane
                req={<DeleteRequestBox operationObject={operationObject} />}
                res={<ResponseBox responsesObject={responses} />}
            />
        </Box>
    );
};

export default Delete;
